<template>
    <div class="left-menu" v-if="$parent.vipInfo.level != ''">
        <div v-if="$route.meta.keepAlive=='1'">
            <div class="logo">
                <a href="#"><img :src="$parent.logos[$parent.projectType]" /></a>
                <div class="logo-label">{{$parent.vipInfo.level === 20 ? '机构版' : '个人版'}}</div>
            </div>
            <div class="inside">
                <ul class="naver">
                    <li class="clearfix" v-for="(item,index) in newNav" :key='index'>
                        <router-link class="db" :class="$route.meta.pageActive==1&&item.id==5?'router-link-active':''" :to='item.path'><i :class="'icons nav-icon'+item.id"></i>{{item.name}}</router-link>
                    </li>
                </ul>    
            </div>
        </div>
        <div class="" v-if="$route.meta.keepAlive=='2'">
            <div class="logo">
                <div class="pr-logo"><img :src="$parent.vipInfo.picurl" /></div>
                <div class="logo-numb">{{$parent.vipInfo.username}}</div>
                <div class="grade mt10">
                    <i class="icons" :class="$parent.vipInfo.icon" v-if="$parent.vipInfo.level != 1"></i>
                    <span class="en-name">{{$parent.vipInfo.levelName}}</span>
                </div>
            </div>
            <div class="inside">
                <ul class="naver"> 
                    <li class="clearfix">
                        <router-link class="db" to='/personalCenter'><i class="icons user-icon1"></i>我的会员</router-link>
                    </li>
                    <li class="clearfix">
                        <router-link class="db" to='/myDownload'><i class="icons user-icon2"></i>我的下载</router-link>
                    </li>
                </ul>    
            </div>            
        </div>
    </div>
</template>
<script>
export default {
    name: "left",
    props: '',
    data() {
        return {
            nav:[
                {name: '账号列表', path: '/accountList',id:'1',level:1,userType:2},
                {name: '素材中心', path: '/materialCenter',id:'2',level:1,userType:2},
                {name: '在线编辑', path:'/onlineEdit',id:'3',level:1,userType:2},
                {name: '任务指令', path:'/taskOrders',id:'4',level:2,userType:2},
                {name: '数据分析', path:'/wxdataAnalysis',id:'5',level:1,userType:2},
                {name: '媒体榜单', path:'/mediaList',id:'6',level:1,userType:2},
                {name: '用户管理', path:'/userManagement',id:'7',level:2,userType:1},
            ],
            navIndex:0,
            newNav:[],//权限新导航
            isSelect: '账号列表', 
            active:false,
        }
    },
    mounted() {
        let that = this;
        // that.isSelect = that.$route.name;
        // if(that.$route.path=='/wbdataAnalysis'){
        //     that.active=true;
        // }
    },
    created() {
        
    },
    methods: {    
        //判断权限过滤路由
        powerFilter () {
            let that = this;
            if(that.$parent.projectType === 0){
                if(that.$parent.vipInfo.level != 20){//个人用户
                    let nav = that.nav.filter(function (i){
                        return i.level === 1;
                    })
                    that.newNav = nav;
                }else if(that.$parent.vipInfo.userType === 2){
                    let nav = that.nav.filter(function (i){
                        return i.userType === 2;
                    })
                    that.newNav = nav;
                }else if(that.$parent.vipInfo.userType === 1){
                    that.newNav = that.nav;
                }
            }else if(that.$parent.projectType === 1){//颜如玉
                that.newNav = [
                    {name: '账号列表', path: '/accountList',id:'1',level:1,userType:2},
                    {name: '数据分析', path:'/wxdataAnalysis',id:'5',level:1,userType:2}
                ]
            }
        }
    }
}
</script>
<style lang="" scope>
    .logo{text-align: center;padding:23px 0 20px;}
    .logo a{display: block;}
    .logo-label{background: linear-gradient(to left,#0095eb, #00c2eb);height: 19px;display: inline-block;margin:20px 0 0;border-radius: 20px;padding: 0 10px;font-size: 12px;color:#fff;}
    .left-menu{width:200px;position:fixed;left:0;top:0;bottom:0;background:#1b1d26;z-index:1000;}
    .left-fang{padding:24px 0 24px 32px;}
    .left-fang .btn{width:136px;}
    .left-fang .text{position:relative;margin:15px 0;padding-right:25px;line-height:34px;color:#fff;}
    .left-fang .text:after{content:'';position:absolute;top:10px;right:16px;width:8px;height:14px;}
    .left-fang .text .fa-icon{margin:8px 9px 0 0;}

    .naver li{line-height:54px;}
    .naver li a{position:relative;padding-left:42px;color:#8a8f99;}
    .naver li a.router-link-active,.naver li a:hover{background:#13151c;color:#fff;}
    .naver li a.router-link-active::before,.naver li a:hover:before{content:'';width:5px;height:54px;position:absolute;top:0;left:0;background:linear-gradient(to bottom,#0095eb, #00c2eb);}
    .naver li .icons{margin:16px 9px -6px 0;display: inline-block;width:20px;height:20px;}
    .nav-icon1{background-position:0 0;}
    .router-link-active .nav-icon1,.naver li:hover .nav-icon1{background-position:-28px 0;}
    .nav-icon2{background-position:0 -26px;}
    .router-link-active .nav-icon2,.naver li:hover .nav-icon2{background-position:-28px -26px;}
    .nav-icon3{background-position:0 -54px;}
    .router-link-active .nav-icon3,.naver li:hover .nav-icon3{background-position:-28px -54px;}
    .nav-icon4{background-position:0 -82px;}
    .router-link-active .nav-icon4,.naver li:hover .nav-icon4{background-position:-28px -82px;}
    .nav-icon5{background-position:0 -110px;}
    .router-link-active .nav-icon5,.naver li:hover .nav-icon5{background-position:-28px -110px;}
    .nav-icon6{background-position:0 -139px;}
    .router-link-active .nav-icon6,.naver li:hover .nav-icon6{background-position:-28px -139px;}
    .nav-icon7{background-position:0 -167px;}
    .router-link-active .nav-icon7,.naver li:hover .nav-icon7{background-position:-28px -167px;}
    .logo-numb{font-size: 16px;color:#fff;}
    .pr-logo{width:72px;height:72px;overflow:hidden;border-radius:50%;margin:0 auto 10px;}
    .user-icon1{background-position:-27px -330px;}
    .active .user-icon1,.naver li:hover .user-icon1{background-position:-47px -330px;}
    .user-icon2{background-position:-27px -353px;}
    .active .user-icon2,.naver li:hover .user-icon2{background-position:-47px -353px;}
</style>



// WEBPACK FOOTER //
// src/components/left.vue